import { Text } from '../../cdl/Text/Text';
import { formatNumber } from '../../common/helpers/formatNumber.helper';
import { translate } from '../../common/helpers/translate.helper';

import { DemandNumber } from './DemandNumber';

interface DemandLiftingCountProps {
    count: number;
}

export const DemandLiftingCount = ({ count }: DemandLiftingCountProps) => (
    <Text variant="extraSmall" color="foreground.subtle">
        <DemandNumber>
            {translate('demandDefinition.liftingsCount', {
                count: formatNumber({ number: count, maximumFractionDigits: 0 }),
            })}
        </DemandNumber>
    </Text>
);
